<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div (cdkDragEnded)="dragEnded($event)" cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-window-content restorable-window">
    <div cdkDragHandle class="modal-header">
        <h4>Overloaded frozen PtMP sectors</h4>
        <button (click)="closeModal()" matDialogClose windeClose>
            <sui-svg-icon icon="cross" />
        </button>
    </div>

    <div *ngIf="!historyService || !reportData || !reportData.length" class="modal-body">
        <h6>No overloaded PtMP sectors in this topology</h6>
    </div>

    <div *ngIf="historyService && reportData && reportData.length" class="modal-body modal-body--fixed-header">
        <div #scrollContainer class="modal-body__scroll-content">
            <ul class="list-unstyled pt-3 sectors-list">
                <li *ngFor="let sector of reportData; trackBy: trackSector" class="sectors-list__item sector sector--{{ sector.sectIdx }}">
                    <h6>
                        Sector {{ sector.sectIndev }} from
                        <winde-node-pointer [listData]="{ nodeNames: sector.nodeid, placement: 'top', cropName: 10 }"></winde-node-pointer>
                    </h6>
                    <div *ngIf="sector.sectorLinkData.length" class="grid">
                        <!-- HEADER -->
                        <div class="grid-row">
                            <div class="grid-row__cell">Link Identification</div>
                            <div class="grid-row__cell state-cell">Frozen / Installed</div>
                        </div>

                        <!-- BODY -->
                        <div *ngFor="let link of sector.sectorLinkData; trackBy: trackLinkData" class="grid-row">
                            <div class="grid-row__cell">
                                <winde-link-pointer
                                    [linkData]="{
                                        nodeFrom: link.node0Id,
                                        nodeTo: link.node1Id,
                                        name: link.node0Id + ' - ' + link.node1Id
                                    }"
                                ></winde-link-pointer>
                            </div>
                            <div class="grid-row__cell state-cell">
                                @if (link.isUserForced && !link.isInstalled) {
                                    <button windeActionIcon>
                                        <sui-svg-icon icon="lock" windeGrey />
                                    </button>
                                }
                                @if (link.isUserForced && link.isInstalled) {
                                    <button windeActionIcon>
                                        <sui-svg-icon icon="podcast" windeGrey />
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>
